import { css } from "@mui/material";

const CommonTypographyStyle = css`
  text-align: center;
  letter-spacing: -0.01em;
  font-style: normal;
`;

//HeadLine H2

export const H2 = css`
  ${CommonTypographyStyle}
  font-size: 30px;
  line-height: 38px;
`;

export const H2_REGULAR = css`
  ${H2}
  font-weight: 400;
`;

export const TEXT_11 = css`
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.2em;
`;

export const TEXT_16_500 = css`
  /* Body-sm */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.32px;
`;

export const TEXT_16 = css`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.02em;
`;

// font size 16 and line height 24 text align center
export const TEXT_16_H24 = css`
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.02em;
`;

export const TEXT_18 = css`
  font-size: 18px;
  line-height: 32px;
  letter-spacing: -0.02em;
`;

export const TEXT_20 = css`
  font-size: 20px;
  line-height: 32px;
  letter-spacing: -0.02em;
`;

export const TEXT_20_500 = css`
  ${TEXT_20}
  font-style: normal;
  font-weight: 500;
`;

export const TEXT_24 = css`
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  letter-spacing: -0.07em;
`;

export const TEXT_24_700 = css`
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -1.2px;
`;

export const TEXT_32 = css`
  font-size: 32px;
  letter-spacing: -0.07em;
`;

export const TEXT_36 = css`
  font-size: 36px;
  line-height: 36px;
  letter-spacing: -0.05em;
`;

export const TEXT_40 = css`
  font-size: 40px;
  line-height: 40px;
  letter-spacing: -0.05em;
`;

export const TEXT_48_CENTER = css`
  font-size: 48px;
  line-height: 56px;
  text-align: center;
  letter-spacing: -0.05em;
`;

export const TEXT_50 = css`
  font-size: 50px;
  line-height: 50px;
`;

export const TEXT_56 = css`
  font-size: 56px;
  line-height: 56px;
  letter-spacing: -0.05em;
`;

export const TEXT_64 = css`
  font-size: 64px;
  line-height: 72px;
  letter-spacing: -0.05em;
`;

export const TEXT_96 = css`
  font-size: 96px;
  line-height: 96px;
  letter-spacing: -0.05em;
`;
